import { trimByLength } from '../helpers/trim-by-length';
import { getCookie } from '../helpers/cookie';
import { updateCustomIdentifiers } from '../helpers/update-custom-identifiers';
import { hashByConfig } from '../helpers/hash-by-config';
import { PROFILE_COOKIE_NAMES } from '../config/constants';
import { getUTMUrlProperties } from '../helpers/get-utm-url-params';
const APPLICATION_LANGUAGE_LENGTH = 16;
const CLIENT_BLOCK_LENGTH = 64;
const APP_VERSION_LENGTH = 16;

/**
 * Структура настроек профиля для пакета событий
 */

/**
* Блок данных о клиенте
*/

const profile = {};
export const getProfileCookie = () => {
  const result = [];
  PROFILE_COOKIE_NAMES.forEach(cookieName => {
    const value = getCookie(cookieName);
    if (value) {
      result.push({
        key: cookieName,
        value: trimByLength(value)
      });
    }
  });
  return result.length > 0 ? result : void 0;
};

/**
 * Установка настроек профиля для пакета событий
 * @param {Profile} profile объект настроек профиля
 * @return {void}
 */
export const setProfile = nextProfile => {
  Object.assign(profile, {
    ...nextProfile,
    clientBlock: trimByLength(nextProfile.clientBlock, CLIENT_BLOCK_LENGTH),
    hashUserLoginId: trimByLength(nextProfile.hashUserLoginId),
    appVersion: trimByLength(nextProfile.appVersion, APP_VERSION_LENGTH),
    ...(nextProfile.adId && {
      adId: trimByLength(nextProfile.adId)
    }),
    ...(nextProfile.appId && {
      appId: trimByLength(nextProfile.appId)
    }),
    ...(nextProfile.subId && {
      subId: trimByLength(nextProfile.subId)
    }),
    ...(nextProfile.sapId && {
      sapId: trimByLength(nextProfile.sapId)
    }),
    ...(nextProfile.partnerId && {
      partnerId: trimByLength(nextProfile.partnerId)
    })
  });
};
/**
 * Совокупность методов установки специфичных параметров профиля
 */
export const profileUpdater = {
  /**
   * Установка email клиента
   * @param {String} value значение email
   * @param {Boolean} enableHash признак хэширования
   * @return {ProfileUpdater} profileUpdater
   */
  setEmail(value, enableHash) {
    updateCustomIdentifiers({
      entity: profile,
      key: 'email',
      value: hashByConfig(value, enableHash)
    });
    return this;
  },
  /**
   * Установка phone number клиента
   * @param {String} value значение phone number
   * @param {Boolean} enableHash признак хэширования
   * @return {ProfileUpdater} profileUpdater
   */
  setPhone(value, enableHash) {
    updateCustomIdentifiers({
      entity: profile,
      key: 'phoneNumber',
      value: hashByConfig(value, enableHash)
    });
    return this;
  },
  /**
   * Установка sbClientId клиента
   * @param {String} value значение sbClientId
   * @param {Boolean} enableHash признак хэширования
   * @return {ProfileUpdater} profileUpdater
   */
  setSbClID(value, enableHash) {
    updateCustomIdentifiers({
      entity: profile,
      key: 'sberClientId',
      value: hashByConfig(value, enableHash)
    });
    return this;
  },
  /**
   * Установка ClientId клиента
   * @param {String} value значение ClientId
   * @param {Boolean} enableHash признак хэширования
   * @return {ProfileUpdater} profileUpdater
   */
  setClientID(value, enableHash) {
    profile.hashUserLoginId = hashByConfig(value, enableHash);
    return this;
  },
  /**
   * Установка значения некоторого идентификатора в profile
   * @param {String} key ключ идентификатора
   * @param {String} value значение идентификатора
   * @param {Boolean} enableHash признак хэширования
   * @return {MetaUpdater} metaUpdater
   */
  setProfileID(key, value, enableHash) {
    updateCustomIdentifiers({
      entity: profile,
      key,
      value: hashByConfig(value, enableHash)
    });
    return this;
  }
};
export const getProfile = async ({
  sessionId,
  deviceId
}) => {
  const cookie = getProfileCookie();
  const utm = getUTMUrlProperties();
  return {
    ...profile,
    applicationLanguage: trimByLength(globalThis.document?.documentElement.lang, APPLICATION_LANGUAGE_LENGTH),
    deviceId,
    sessionId,
    ...(cookie && {
      cookie
    }),
    ...(utm && {
      utm
    })
  };
};